export const BADGE_MEMBER_STATUSES = {
    LOCKED: 'Locked',
    ACHIEVED: 'Achieved',
    IN_PROGRESS: 'In Progress',
} as const;

export type BadgeMemberStatus = (typeof BADGE_MEMBER_STATUSES)[keyof typeof BADGE_MEMBER_STATUSES];
